export enum MessageDirection {
    SENT = "SENT",
    RECEIVED = "RECEIVED"
  }
  